export default __webpack_public_path__ + "static/media/illustrationCompanyRedencao.5fc4c2eb.svg";